<div class="login-container">
  <div class="login-card animate-slide-in">
    <!-- Logo -->
    <div class="logo-container">
      <div class="logo">
        <svg width="144" height="80"  class="crown-icon" viewBox="0 0 144 80" fill="none" xmlns="http://www.w3.org/2000/svg">
          <g clip-path="url(#clip0_1176_5258)">
            <path
              d="M88.044 8.22729C88.1727 8.27187 88.3072 8.30062 88.4518 8.30062C89.1458 8.30062 89.7083 7.7413 89.7083 7.0497C89.7083 6.3581 89.1458 5.80022 88.4518 5.80022C87.7577 5.80022 87.1952 6.35954 87.1952 7.0497C87.1952 7.41923 87.3586 7.74706 87.6146 7.97567L83.0498 13.0268C82.5798 13.5473 81.7123 13.2569 81.6545 12.5609L81.1325 6.37392C82.013 6.30203 82.7056 5.56873 82.7056 4.67439C82.7056 3.73117 81.9379 2.96768 80.9893 2.96768C80.0408 2.96768 79.273 3.73117 79.273 4.67439C79.273 5.34442 79.662 5.92244 80.2273 6.20282L77.0578 12.5566C76.7325 13.2094 75.7695 13.1217 75.5685 12.4215L72.9543 3.34583C73.6715 3.14165 74.1978 2.486 74.1978 1.70525C74.1978 0.763466 73.43 -0.00146484 72.4815 -0.00146484C71.533 -0.00146484 70.7652 0.763466 70.7652 1.70525C70.7652 2.48456 71.2915 3.14165 72.0087 3.34583L69.3944 12.4215C69.1934 13.1217 68.2305 13.208 67.9051 12.5566L64.7356 6.20282C65.301 5.92387 65.69 5.34586 65.69 4.67439C65.69 3.73117 64.9222 2.96768 63.9736 2.96768C63.0251 2.96768 62.2573 3.73117 62.2573 4.67439C62.2573 5.61761 62.9499 6.30203 63.8305 6.37392L63.3085 12.5609C63.2492 13.2569 62.3831 13.5473 61.9132 13.0268L57.3484 7.97567C57.6043 7.74706 57.7677 7.41779 57.7677 7.0497C57.7677 6.35954 57.2053 5.80022 56.5112 5.80022C55.8172 5.80022 55.2547 6.35954 55.2547 7.0497C55.2547 7.73987 55.8172 8.30062 56.5112 8.30062C56.6544 8.30062 56.7903 8.27187 56.9175 8.22729L59.9583 17.0168H85.0061L88.0469 8.22729H88.044Z"
              fill="#233978" />
            <path d="M86.348 17.845H58.6339V19.4194H86.348V17.845Z" fill="#233978" />
            <path
              d="M4.42599 33.9114C6.59199 33.9114 7.54341 33.9818 8.59026 34.4793C9.66169 34.9998 10.6362 36.1127 10.6362 37.7217C10.6362 39.4959 9.70796 41.1768 7.44798 41.8871L12.0402 49.5306H7.87597L4.40141 42.8576H3.73483V49.5306H0V33.9128H4.42599V33.9114ZM3.73628 36.0178V41.0114H4.35514C5.25884 41.0114 6.8537 41.0114 6.8537 38.337C6.8537 36.0178 5.54514 36.0178 4.40285 36.0178H3.73628Z"
              fill="#233978" />
            <path d="M17.6346 33.9114V49.5292H13.8029V33.9114H17.6346Z" fill="#233978" />
            <path
              d="M28.0568 36.4665C27.2471 36.1358 26.5574 35.946 25.7245 35.946C24.4637 35.946 23.7262 36.5614 23.7262 37.4126C23.7262 38.1229 24.2265 38.6909 25.4628 39.637L26.2479 40.2279C28.1999 41.6715 29.6271 42.8549 29.6271 45.1971C29.6271 47.6817 27.7474 49.7637 24.4637 49.7637C22.6794 49.7637 21.5125 49.2432 20.5842 48.7701L21.5357 46.6882C22.4394 47.1382 23.2968 47.5163 24.3437 47.5163C25.6768 47.5163 26.2479 46.7356 26.2479 45.9549C26.2479 45.0792 25.5814 44.5113 24.3205 43.5407L23.5831 42.9728C21.6557 41.5292 20.3471 40.1805 20.3471 38.0985C20.3471 35.6139 22.4885 33.6973 25.5351 33.6973C27.0577 33.6973 28.1522 34.0999 28.8434 34.3831L28.0582 36.4651L28.0568 36.4665Z"
              fill="#233978" />
            <path
              d="M40.8128 33.9114V36.2062H35.7433V40.3241H40.431V42.5255H35.7433V47.2114H40.8836V49.5306H31.9116V33.9128H40.8113L40.8128 33.9114Z"
              fill="#233978" />
            <path
              d="M55.6147 33.9114L61.2307 49.5292H57.3036L56.0659 45.7189H51.7353L50.4976 49.5292H47.8559L53.3533 33.9114H55.6147ZM52.3542 43.7318H55.4485L53.9259 38.8331L52.3556 43.7318H52.3542Z"
              fill="#233978" />
            <path d="M72.2501 33.9114V36.1602H68.2999V49.5306H64.4682V36.1602H60.541V33.9114H72.2487H72.2501Z"
              fill="#233978" />
            <path
              d="M78.0801 33.9114V40.3716H82.3167V33.9114H86.1238V49.5292H82.3167V42.501H78.0801V49.5292H74.2484V33.9114H78.0801Z"
              fill="#233978" />
            <path d="M93.6441 33.9114V47.2574H98.5704V49.5292H89.8124V33.9114H93.6441Z" fill="#233978" />
            <path
              d="M109.374 33.9114V36.2062H104.305V40.3241H108.993V42.5255H104.305V47.2114H109.445V49.5306H100.473V33.9128H109.373L109.374 33.9114Z"
              fill="#233978" />
            <path d="M122.106 33.9114V36.1602H118.155V49.5306H114.324V36.1602H110.397V33.9114H122.104H122.106Z"
              fill="#233978" />
            <path
              d="M133.005 33.9114V36.2062H127.936V40.3241H132.623V42.5255H127.936V47.2114H133.076V49.5306H124.104V33.9128H133.004L133.005 33.9114Z"
              fill="#233978" />
            <path
              d="M142.43 36.4665C141.62 36.1358 140.93 35.946 140.097 35.946C138.837 35.946 138.098 36.5614 138.098 37.4126C138.098 38.1229 138.598 38.6909 139.834 39.637L140.619 40.2279C142.571 41.6715 143.999 42.8549 143.999 45.1971C143.999 47.6817 142.119 49.7637 138.835 49.7637C137.051 49.7637 135.884 49.2432 134.956 48.7701L135.907 46.6882C136.811 47.1382 137.668 47.5163 138.715 47.5163C140.048 47.5163 140.619 46.7356 140.619 45.9549C140.619 45.0792 139.953 44.5113 138.692 43.5407L137.955 42.9728C136.027 41.5292 134.719 40.1805 134.719 38.0985C134.719 35.6139 136.86 33.6973 139.907 33.6973C141.429 33.6973 142.524 34.0999 143.215 34.3831L142.43 36.4651V36.4665Z"
              fill="#233978" />
            <path d="M87.8682 22.3984L118.589 26.6846L144 28.9854H0.959961L26.3711 26.6846L57.0918 22.3984H87.8682Z"
              fill="#27AAE1" />
            <path
              d="M72.4512 63.7305L26.3711 57.5391L0.959962 55.2392L144 55.2393L118.589 57.5391L72.5088 63.7305L72.4512 63.7305Z"
              fill="#27AAE1" />
          </g>
          <defs>
            <clipPath id="clip0_1176_5258">
              <rect width="144" height="80" fill="white" />
            </clipPath>
          </defs>
        </svg>
      </div>
    </div>

    <!-- Header -->
    <div class="login-header">
      <h1>Log in to your account</h1>
      <p>Welcome back! Please enter your details.</p>
    </div>

    <!-- Error Message -->
    <div class="error-message" *ngIf="errorMessage">
      {{ errorMessage }}
    </div>

    <!-- Form -->
    <form class="login-form" (ngSubmit)="onSubmit()">
      <!-- Phone Number Field -->
      <div class="form-group">
        <label for="phoneNumber">Phone Number</label>
        <input
          type="tel"
          id="phoneNumber"
          name="phoneNumber"
          [(ngModel)]="phoneNumber"
          placeholder="+20 100 000 0001"
          required
          autocomplete="tel"
          [disabled]="isLoading" />
      </div>

      <!-- Password Field -->
      <div class="form-group">
        <label for="password">Password</label>
        <input
          type="password"
          id="password"
          name="password"
          [(ngModel)]="password"
          placeholder="••••••••"
          required
          autocomplete="current-password"
          [disabled]="isLoading" />
      </div>

      <!-- Remember & Forgot -->
      <div class="form-options">
        <label class="checkbox-label">
          <input type="checkbox" name="remember" [(ngModel)]="rememberMe" [disabled]="isLoading" />
          <span class="checkbox-text">Remember for 30 days</span>
        </label>
        <a href="#" class="forgot-link">Forgot password</a>
      </div>

      <!-- Sign In Button -->
      <button type="submit" class="btn btn-primary btn-block" [disabled]="isLoading">
        <span *ngIf="!isLoading">Sign in</span>
        <span *ngIf="isLoading">Signing in...</span>
      </button>
    </form>

    <!-- Language Selector -->
    <div class="language-selector">
      <svg viewBox="0 0 24 24" class="globe-icon">
        <path fill="currentColor"
          d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-1 17.93c-3.95-.49-7-3.85-7-7.93 0-.62.08-1.21.21-1.79L9 15v1c0 1.1.9 2 2 2v1.93zm6.9-2.54c-.26-.81-1-1.39-1.9-1.39h-1v-3c0-.55-.45-1-1-1H8v-2h2c.55 0 1-.45 1-1V7h2c1.1 0 2-.9 2-2v-.41c2.93 1.19 5 4.06 5 7.41 0 2.08-.8 3.97-2.1 5.39z" />
      </svg>
      <select class="language-select">
        <option value="en">English</option>
        <option value="ar">العربية</option>
        <option value="es">Español</option>
        <option value="fr">Français</option>
      </select>
    </div>
  </div>
</div>